import * as types from '../constants/ActionTypes';
import { loadUserInfo } from "../services/firebase/user";
import { 
  getChat, 
  getAllChatsOfUser, 
  loadUserChatInfo, 
  sendChatMessage, 
  updateChatStatus 
} from "../services/firebase/chats";

export function getUserChatsAction(currentUserId) {
  return (dispatch) => {

    getAllChatsOfUser(currentUserId).then(chats => {
      let promises = []

      for (let key in chats) {
        let usersId = key.split('-');
        let companionId = currentUserId && usersId.find(id => id !== currentUserId);
        promises.push(loadUserChatInfo(companionId, chats[key], key))
      }

      Promise.all(promises).then(values => {
        dispatch(addAllChatСompanionStore(values));
      });
    })
  }
}

export function moderateChatsAction(chats, currentUserId) {
  return (dispatch) => {
    let promises = []

    for (let key in chats) {
      let usersId = key.split('-');
      let isUserChat = key.indexOf(currentUserId) + 1;
      let companionId = currentUserId && usersId.find(id => id !== currentUserId);
      isUserChat && promises.push(loadUserChatInfo(companionId, chats[key], key))
    }

    Promise.all(promises).then(values => {
      dispatch(addAllChatСompanionStore(values));
    });
  }
}

export function addAllChatСompanionStore(payload) {
  return {
    type: types.ADD_ALL_CHATS,
    payload,
  };
}

export function sendChatMessageAction(messageData, chatId) {
  return (dispatch) => {
    return sendChatMessage(messageData, chatId)
  }
}

export function getChatAction(chatId, currentUserId) {
  return (dispatch) => {
    let usersId = chatId.split('-');
    let companionId = currentUserId && usersId.find(id => id !== currentUserId)

    getChat(chatId, currentUserId).then((chatMessages) => {
      return loadUserInfo(companionId).then((companionData) => {
        let chatObject = {
          [companionId]: {
            companionData: companionData,
            chat: chatMessages
          }
        };

        dispatch(addChatСompanionStore(chatObject));
      })
    })
  };
}

export function addChatСompanionStore(payload) {
  return {
    type: types.ADD_CHAT_COMPANION,
    payload,
  };
}

export function deleteChatsStore() {
  return {
    type: types.DELETE_ALL_CHATS
  };
}

export function updateChatStatusAction(chat, chatId) {
  return (dispatch) => {
    return updateChatStatus(chat, chatId)
      .then(() => {
        const payload = {
          chat,
          chatId
        };

        dispatch(updateChatStatusStore(payload));
      })
  }
}

export function updateChatStatusStore(payload) {
  return {
    type: types.UPDATE_CHAT_STATUS,
    payload
  };
}

export function updateMessageNotification(payload) {
  return {
    type: types.UPDATE_MESSAGE_NOTIFICATION,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/actions/chatStoreActions.js